import { EditorSpecialField } from "@dev/template-editor";

export enum SpecialFieldGroup {
    CONTACT = 'Contact',
    ACCOUNT_PROFILE = 'Account profile',
    GENERAL = 'General',
    CUSTOM = 'Custom',
    CHECKOUT = 'Checkout'
}
export interface SpecialField extends EditorSpecialField {
    id: string;
    displayName?: string;
    group: SpecialFieldGroup;
    regexKeyword?: string;
    additionalValueTitle?: string;
    additionalValueTitleTooltip?: string;
    additionalValueDescription?: string;
    additionalValuePlaceholder?: string;
    additionalValueError?: string;
    additionalValueMaxLength?: number;
    requiredText?: string;
    isUIOnly?: boolean;
    getTextValueToInsert?: (text: string) => string;
}

export interface SpecialFieldToInsert {
    value: string;
    fullValue: string;
    textValue?: string;
    isAdditonalValueEmptyButRequired: boolean;
    isValid?: boolean;
}
